import styled from "styled-components";
import {TooltipArrowDefaultBox} from "./tooltip-arrow.default";

export const TooltipArrow777Box = styled(TooltipArrowDefaultBox)`
    &:before {
      border-top: 1px solid ${({borderColor}) => borderColor ? borderColor : 'gray'};
      border-left: 1px solid ${({borderColor}) => borderColor ? borderColor : 'gray'};
    }   
`;